<script>
import Layout from "../../../../layouts/main";
import PageHeader from "@/components/page-header";
import {RestaurantsPath,BrandsPath,GravyPath} from "@/path.js";
import 'vue2-datepicker/index.css';
/* Dashboard component */
export default {
  components: {
    Layout,
    PageHeader,
  },
  computed : {
    RestaurantsPath(){
      return RestaurantsPath;
    },
    BrandsPath(){
      return BrandsPath;
    },
    GravyPath(){
      return GravyPath;
    }
  },
  data() {
    return {
      title: "Restaurant",
      items: [
        {
          text: "Analytics",
        },
        {
          text: "Restaurant",
          active: true,
        },
      ],
      payload : {
        resource: { dashboard: this.$store.state.authfack.user.roles.filter(f => f.name == 'RestaurantPartner').length > 0 ? 30 : 11 },
        params: {},
        exp: Math.round(Date.now() / 1000) + (10 * 60) // 10 minute expiration
      },
      token : process.env.VUE_APP_METABASE_SECRET_KEY,
      metabase_url : process.env.VUE_APP_METABASE_SITE_URL,
      iframe_url : null,
      key : 0,
      nowtime : Date.now()
    };
  },
  watch : {

  },
  methods : {
    async loadUrl(){
      var jwt = require('jsonwebtoken');
      const signOptions = { algorithm: 'HS256'};
      console.log(this.payload);
      if(this.$store.state.authfack.user.roles.filter(f => f.name == 'RestaurantPartner').length > 0){
        this.payload.params.restataurant = [this.$store.state.authfack.user.restaurant.name];
      }      
      var token = await jwt.sign(this.payload, this.token, signOptions);
      this.iframe_url = this.metabase_url + "/embed/dashboard/" + token + "#bordered=true";
      this.key += 1;
    }
  },
  mounted() {
    this.$nextTick(async () => {
      await this.loadUrl()
      // var token = jwt.sign({ foo: 'bar' }, 'shhhhh');
      // console.log(token);

    });
  }
};
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <b-card>
      <b-card-header>Restaurant Analytics</b-card-header>
      <b-card-body :key="key">
        <iframe
            :src="iframe_url"
            :key="nowtime"
            frameborder="0"
            width="100%"
            height="100%"
            style="min-height: 100vh;"
            allowtransparency
        ></iframe>
      </b-card-body>
    </b-card>
  </Layout>
</template>
